import React, { useEffect } from 'react';

import { Card } from '../../common/Card';
import { usePageTitle } from '../../PageTitleContext';
import { ChangePasswordForm } from './ChangePasswordForm';

type ChangePasswordProps = {};

export function ChangePassword({}: ChangePasswordProps) {
  const { setPageTitle } = usePageTitle();

  useEffect(() => {
    setPageTitle('Change password');
  }, []);

  return (
    <Card
      style={{ padding: 20, width: 350, alignSelf: 'center', margin: '0 auto' }}
    >
      <h2>Change password</h2>
      <ChangePasswordForm />
    </Card>
  );
}
